"use strict";

export function initInScope ($scope) {
    $scope.find('.js-ajax-price__form').on('submit',function (e) {
        e.preventDefault();

        var url= $(this).attr('action');

        $.ajax(url, {
            type: "POST",
            data: $(this).serialize(),
            dataType: 'json',
            headers: {ajax: true}
        }).done(function (data) {
            if(data) {
                $.each(data, function (i) {
                    let $teaser = $('[data-object-id="' + data[i].id + '"]');

                    $teaser.find('.js-ajax-price__price').html(data[i].price).removeClass('is-blurry');
                });
            }
        }).fail(function(a){
            console.warn(a);
            alert('Es ist ein Fehler aufgetreten. Versuchen Sie es später nochmals.')
        });
    });

    $scope.find('.js-ajax-price__form').submit();
}